var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3H20C21.1046 3 22 3.89543 22 5V22C22 23.1046 21.1046 24 20 24H4C2.89543 24 2 23.1046 2 22V5C2 3.89543 2.89543 3 4 3H9C9 1.34315 10.3431 0 12 0C13.6569 0 15 1.34315 15 3ZM13 3C13 3.55228 12.5523 4 12 4C11.4477 4 11 3.55228 11 3C11 2.44772 11.4477 2 12 2C12.5523 2 13 2.44772 13 3ZM6.25 9.75C6.25 10.1642 6.58579 10.5 7 10.5L17 10.5C17.4142 10.5 17.75 10.1642 17.75 9.75C17.75 9.33579 17.4142 9 17 9L7 9C6.58579 9 6.25 9.33579 6.25 9.75ZM7 14.5C6.58579 14.5 6.25 14.1642 6.25 13.75C6.25 13.3358 6.58579 13 7 13L17 13C17.4142 13 17.75 13.3358 17.75 13.75C17.75 14.1642 17.4142 14.5 17 14.5L7 14.5ZM7 18.75H14C14.4142 18.75 14.75 18.4142 14.75 18C14.75 17.5858 14.4142 17.25 14 17.25H7C6.58579 17.25 6.25 17.5858 6.25 18C6.25 18.4142 6.58579 18.75 7 18.75Z",
    fill: "#212122"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12) rotate(90) scale(24 18.7245)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D74A0E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileOrders);
export default __webpack_public_path__ + "static/media/mobile-orders.64e74fe3c670f8faf79805caed42c3e2.svg";
export { ForwardRef as ReactComponent };